import React, { useState, useEffect } from 'react'

import {Grid} from '@mui/material'

import ComponentContainer from '../../core/template/ComponentContainer';
import {CoreContext} from "../../core/context/CoreContext";
import CompositionEditForm from './CompositionEditForm';
import CompositionList from './CompositionList';
import { useSelector, useDispatch } from 'react-redux';

import Notification from '../../core/components/Notification';

import CompositionListView from './CompositionListView'


export default function CompositionDashboard(){
  const { setKeyValue, getKeyValues, keyvalues } = React.useContext(CoreContext);
  const {showEdit} = useSelector((state)=>state.pharmaslice.compositionDashboard);
  const [ compositionId, setCompositionId] = React.useState('');
  const [reloadCompositionList, setReloadCompositionList] = useState(true);

  return (
      <>
      <Notification/>
      {showEdit?
        <ComponentContainer containedComponent = {
          <CompositionEditForm 
            setReloadCompositionList={setReloadCompositionList}
            compositionId={compositionId}
            />}/>:
            <>
            <Grid container direction="column" >
              <Grid item>
                    {
                      <CompositionListView 
                      setCompositionId = {setCompositionId}/>
                    }
              </Grid>
            </Grid>
            </>
      }
    </>


  )

}
